import React from 'react'

export const NotificationIcon = ({ logo }) => {
  return (
    <img
      src={logo}
      width='30px'
      height='30px'
      style={{ borderRadius: '4px', objectFit: 'contain' }}
    />
  )
}
